<template>
  <sec-cta-band :heading-id="headingId" :title="getInTouch.title" :actions="getInTouch.actions" />
</template>

<script setup>
// Closing "Get in touch with us!" band, placed last on About, Home, Services, Maturity
// Roadmap and Security Baseline. Give the section above it :divider="false".
import SecCtaBand from '@/components/security/ui/SecCtaBand.vue';
import { GET_IN_TOUCH } from '@/content/security/getInTouch';

defineProps({
  headingId: { type: String, default: 'get-in-touch' },
});

const getInTouch = GET_IN_TOUCH;
</script>
